import { Button } from '@chakra-ui/react';
import { PlaylistShareLinkDialog } from 'app/components/Playlist/PlaylistShareLinkDialog';
import { useAppDispatch, useAppSelector } from 'app/store';
import { isPlaylistShareModalOpen } from 'app/store/Shares/selectors';
import { setShareModal } from 'app/store/Shares/slice';

interface PlaylistShareProps {
  guid: string;
  title: string;
}

export const PlaylistShare = ({ guid, title }: PlaylistShareProps) => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(isPlaylistShareModalOpen);
  const setIsOpen = (isOpen: boolean) =>
    dispatch(setShareModal({ isOpen, type: 'playlist' }));

  return (
    <>
      <Button size="sm" onClick={() => setIsOpen(true)}>
        Share Playlist
      </Button>
      <PlaylistShareLinkDialog
        isOpen={isOpen}
        playlistTitle={title}
        onClose={() => setIsOpen(false)}
        playlistGuid={guid}
      />
    </>
  );
};
